<template>
  <div id="app">
      <div class="body_bg container">
        <div class="whitebg mainbg">
          <el-row :gutter="15">
             <Mlogin/>
            <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="rightfloat middle">
              <div class="grid-content bg-purple-light">
                <el-row :gutter="15">
                  <el-col :xs="24" :sm="24" :md="17" :lg="17" :xl="17" class="middle">
                    <div class="tgxz">
                        <div class="title_all">
                          <div class="left">学报简介</div>
                          <span class="title_more">
                            <router-link to="/FixedBody?ItemId=10"></router-link>
                          </span>
                          <div class="clearfix"></div>
                        </div>
                        <el-row :gutter="25" class="pd15">
                          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                            <img :src="ImgUrl+imgUrl" alt width="100%"/>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
                            <div v-html="qkBody"></div>
                          </el-col>
                        </el-row>
                    </div>
                    <div class="dqml fifth">
                      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane label="当前目次" name="first" class="buttona">
                          <IssueArticleListControl  :type="type" v-if="isyuchuban==false"  :List="List" :isdataa="true" :newListTitle="newListTitle" :Periods="Periods" :id="1" :scroll="true" :CloumnList="CloumnList"></IssueArticleListControl>
                        </el-tab-pane>
                        <el-tab-pane label="优先出版" class="buttona" name="second" v-if="isycb">
                          <IssueArticleListControl  :type="type" v-if="isyuchuban" :isycb="isycb" :List="newList" :Periods="Periods" :id="1" :scroll="true"></IssueArticleListControl>
                        </el-tab-pane>
                      </el-tabs>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7" class="middle middle2">
                     <div class="tgxz" style="border:1px #e8d28f solid">
                      <div class="title_all2">
                        <div class="left2">专题征稿</div>
                        <span class="title_more">
                          <router-link to="/NewsList?ColumnId=20"></router-link>
                        </span>
                        <div class="clearfix"></div>
                      </div>
                      <Control :params="{ColumnId:20,PageSize:8}" :isshow="true"></Control>
                    </div>
                    <div class="tgxz fifth" style="border:1px #e8d28f solid">
                      <div class="title_all2">
                        <div class="left2">信息公告</div>
                        <span class="title_more">
                          <router-link to="/NewsList?ColumnId=14"></router-link>
                        </span>
                        <div class="clearfix"></div>
                      </div>
                      <Control :params="{ColumnId:14,PageSize:8}" :isshow="true"></Control>
                    </div>
                    <div class="tgxz fifth" style="border:1px #e8d28f solid">
                      <div class="title_all2">
                        <div class="left2">期刊信息</div>
                        <div class="clearfix"></div>
                      </div>
                      <div v-html="Info" class="fifth"></div>
                    </div>
                    
                     <!--友情链接-->
                    <div class="tgxz fifth" style="border:1px #e8d28f solid">
                      <div class="title_all2">
                        <div class="left2">友情链接</div>
                        <span class="title_more">
                          <router-link to="/Links"></router-link>
                        </span>
                        <div class="clearfix"></div>
                      </div>
                      <FrLinks></FrLinks>
                    </div>
                    
                  </el-col>
                </el-row>
                
              </div>
            </el-col>
			<DocumentsNewsBlockControl></DocumentsNewsBlockControl>
          </el-row>
        </div>
      </div>
  </div>
</template>
<script>
  import FixedBlockControl from '../components/Home/FixedBlockControl'
  import IssueArticleListControl from '../components/IssueArticleListControl/IssueArticleListControl'
  import xiazai from '@/assets/js/xiazai'
  import vueQr from 'vue-qr'
  import Control from "../components/DocumentsNewsBlockControl/page/Control";
  import Search from '../components/Home/Search.vue';
  import FrLinks from "../components/DocumentsNewsBlockControl/page/FrLinks";
  export default {
    data() {
      return {
        keywords:'',
        activeName: 'first',
        data:{},
        newList:[],
        List:[],
        Lista:[],
        isyuchuban:false,
        cotype:"",
        Periods: {},
        FileGUID:"",
        type:0,
        SetItem:{},
        isycb:false,
        isycba:false,
        isLoginDown:false,
        isEBt:false,
        newListTitle:"",
        recomList:[],
        recomLista:[],
        recomListb:[],
        recomListc:[],
        codeId:0,
        centerDialogVisible: false,
        CloumnList:[],
        getDynamic:[],
        qkBody:'',
        imgUrl:'',
        Info:'',
        OnlineNumber:0,
        Count:0,
        CurrentDay:0,
        Latestbody:''
      }
    },
    components: {
      FixedBlockControl,
      IssueArticleListControl,
      vueQr,
      Control,
      Search,
      FrLinks
    },
    created(){
      this.getArticList();
      this.GetIssue();
      this.getSet();      //获取系统配置
      this.GetRecomList(); //推荐列表
      this.getDynamicList();  //获取期刊动态滚动图片
      this.GetList();
      this.getAllSum()
    },
    mounted(){
        if (this.$route.query.g) {
      window.location.href='/#/ForgetPassword?Guid='+this.$route.query.g
    }
      if(this.$route.query.code){
        this.$store.dispatch("_getWeiXinLogin", {Scene: this.$route.query.code}).then(res=>{
             localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
       })
      }
       
    },
    methods: {
      getAllSum(){
        this.$store.dispatch("_getAllSum").then(res=>{
            this.Count=res.data.Data.Count
            this.CurrentDay=res.data.Data.CurrentDay
            // this.CurrentLast=res.data.Data.CurrentLast
            this.OnlineNumber=res.data.Data.OnlineNumber
        }).catch(err=>{
            console.log(err)
        })
      },
      GetList() {
      this.$store
        .dispatch("_getHeader", [1100, 12,1600])
        .then((res) => {
          if (res.data.IsSuccess) {
            this.qkBody = res.data.Data[0].Body;
            this.Info = res.data.Data[1].Body;
            this.Latestbody = res.data.Data[2].Body;
          } else {
            console.log(res.data.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
      getSet() {
          let params = [1000,1001,4530,6018,6019,230,6055,5000,5010,99,96,11,2960,2900,4554,4553,310]
          //1000:期刊名称
          //1001：期刊英文名称
          //4530：（否）隐藏/（是）显示预出版模块
          //6018:预出版模块显示 （否）文章列表/（是）预出版内容
          //6019：是否需要登录下载文件
          //230：显示/隐藏所有的评论功能
          //6055：显示/隐藏列表和详情页的英文标题，英文关键字，英文摘要
          //5000： ISSN编号
          //5010：CN编号
          //11:是否启用手机短信
          //2900:是否启用英文网刊
          this.$store.dispatch("_getSet",params)
        .then(res => {
          this.SetItem=res.data.Data
          sessionStorage.setItem("SetItem",JSON.stringify(res.data.Data))
          this.SetItem.map((item)=>{
               if(item.SetItemID==4530){
               item.Item_Value=="是"?this.isycb=true:this.isycb=false
                }
                 if(item.SetItemID == 4553){
              this.printNum=item.Item_Value
            }
            if (item.SetItemID == 6018) {
              if (item.Item_Value == "是") {
                this._getLista(this.printNum);
              } else {
                this._getListb(this.printNum);
              }
            }
                if(item.SetItemID==6019){
               item.Item_Value=="是"?this.isLoginDown=true:this.isLoginDown=false
                }
              //   if(item.SetItemID==6055){
              //  item.Item_Value="是"?this.isEBt=true:this.isEBt=false
              //   }
          })
        }).catch(err => {
          console.log(err)
        })			
		
      },
        godigese(ids){
          this.$newOpen('/#/digest?ArticleID='+ids)
        },
      
      oniscode(num){
        this.centerDialogVisible=true
       this.codeId=num
      },
      handleClick(tab, event) {
        if(tab.index=="1"){
          this.type=1
          this.isyuchuban=true
          this.newList=this.Lista
        }
        if(tab.index=="0"){
            this.type=0
             this.isyuchuban=false
             this.newList=this.List
        }
      },
      getArticList() {
      let params = {
        PageSize: 0,
        IssueId: 0
      };
      this.$store
        .dispatch("_getNewlist", params)
        .then(res => {
          this.List = res.data.Data;
          this.Listb = res.data.Data;
          this.List.map(item=>{
            if(item.Column){
              this.CloumnList.push(item)
            }
          })
        })
        .catch(err => {
          console.log(err);
        });
    },
    goExport(ids){
      this.$newOpen('/#/Export?ids='+ids)
    },
      GetIssue() {
      this.$store
        .dispatch("_getYear", { Id: -1})
        .then(res => {
          this.newListTitle = res.data.Data.YearIssue_NoTtitle;
          this.imgUrl=res.data.Data.CoverGUID+res.data.Data.CoverSuffix
          let data={
            newYears:res.data.Data.Publish_Date,
            Volume:res.data.Data.Volume,
            CoverGUID:res.data.Data.CoverGUID,
            CoverSuffix:res.data.Data.CoverSuffix,
            YearIssue_NoTtitle:res.data.Data.YearIssue_NoTtitle
          }
          
          sessionStorage.setItem("newYears",JSON.stringify(data))
          this.Periods = res.data.Data;
          // if (res.data.Data.CoverGUID) {
          //   this.CoverGUID = true;
          // }
          // if (res.data.Data.BackCoverGUID) {
          //   this.BackCoverGUID = true;
          // }
          // if (res.data.Data.CoverGUID) {
          //   this.TableConGUID = true;
          // }
          // if (res.data.Data.RSS) {
          //   this.Rss = true;
          // }
        })
        .catch(err => {
          console.log(err);
        });
    },
    
	GetRecomList(){
			var time =new Date().getTime()
			let data = {
			  "PageSize":4,
        "Type":'Sort',
        "Key":"Recommended",
        "PageIndex":1
			}
			this.$store.dispatch("_getListb",data).then(res=>{
        if(res.data.IsSuccess){
          this.recomListc=res.data.Data
          for(let i=0;i<this.recomListc.length;i++){
            if(i<2){
              this.recomLista.push(this.recomListc[i])
            }else{
              this.recomListb.push(this.recomListc[i])
            }
          }
          this.recomList.push(this.recomLista)
          this.recomList.push(this.recomListb)
        }
        
      }).catch(err=>{
        console.log(err)
      })
		},
     pdf(i, size, guid) {
      if (size <= 0) {
        alert("文件不存在");
        return;
      }
      this.$store.dispatch("_getPDF", { Id: guid }).then(Result => {
        window.location.href =  Result.request.responseURL;
  })

    },
    goHtml(url){
      window.open(url, "_blank");
    },
    _getLista(num) {
      var time = new Date().getTime();
      this.$store
        .dispatch("_getLista", {
          PageSize: num,
          src: time
        })
        .then(res => {
          if (res.data.IsSuccess) {
            this.Lista = res.data.Data;
          }
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
    _getListb(num) {
      var time = new Date().getTime();
      this.$store
        .dispatch("_getListb", {
          PageSize: num,
          Type: "Sort",
          Key: "Preprint",
          src: time
        })
        .then(res => {
          if (res.data.IsSuccess) {
            this.Lista = res.data.Data;
          }
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
    getDynamicList() {
      this.$store
        .dispatch("_getBannerList",{ID:1})
        .then(res => {
          this.getDynamicList = res.data.Data
        })
        .catch(err => {
          console.log(err);
        });
    },  
    }
  }
</script>

<style>
a{
  color: #222222;
}
.qkjj .el-carousel{
  background: #fff;
}

.qkjj .el-carousel__item{
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.item_banner .el-row{
    border: 1px #f1f1f1 solid;
    width: 48%;
    text-align: center;
    padding: 10px 12px;
    min-height: 284px;
    -webkit-box-shadow:rgba(0,0,0,0.09) 0px 6px 9px 0px;
  -moz-box-shadow:rgba(0,0,0,0.09) 0px 6px 9px 0px;
  box-shadow:rgba(0,0,0,0.09) 0px 6px 9px 0px;
}
.qkjj .el-carousel__indicators--horizontal{
  bottom: 20px;
}
.content span{
  margin-right: 15px;
  height: 21px;
  line-height: 21px;
  display: inline-flex;
}
.text{
 text-align: left;
}
.text .title{
  color: #00777b;
  font-size: 16px;
  font-weight: 600;
      width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
}
.qkjj .el-carousel--horizontal{
  overflow: hidden;
}

.text .author{
line-height: 1.5;
margin-bottom: 5px;
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
}
.text .contentText{
  color: #6f6f6f;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    line-height: 1.5;
    margin-bottom: 5px;
    height: 40px;
}
.content span{
  cursor: pointer;
}
.content span i{
display: inline-block; 
width:19px;
height:19px; 
background:url("../assets/images/colum_arrow.png") no-repeat;
}
.content span  .icon1{
  background-position: 0px 2px
}
.content span  .icon2{
  background-position: 0px -17px
}
.content span  .icon3{
  background-position: 0px -36px
}
.el-tabs--card>.el-tabs__header .el-tabs__item{
  border-bottom: none;
}
.dqml .el-tabs__nav-scroll{
  border-bottom: 1px #dedede solid;
}
.dqml .el-tabs__nav-scroll .el-tabs__item{
  border-bottom: none !important;
}
.el-carousel__indicator.is-active button{
  /* background: #00777b !important; */
  background: #fff !important;
}
.el-carousel__item{ background: #dedede;}
.text_carousel{ background: #000; opacity: 0.8;height: 30px; line-height: 30px; color: #fff; position: absolute; bottom: 0; width: 100%; padding: 0 15px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
@media (max-width:992px) {
  .carousel_pic{ margin-bottom: 15px;}
}
.qkdtbanner{ width: 300px; height:225px;}
.mainbg{padding:15px;}
@media (max-width:768px) {
  .middle{padding-left: 0px !important; padding-right: 0 !important;}
  .middle2{ margin-top: 15px;}
}

</style>
